module.exports = __webpack_public_path__ + "img/102.0a4c6241.png";